// Handles old-format email links: /brands/{clientId}
// Redirects to the canonical /r/brand/{clientId} route
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(legacy)/brands/$clientId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/r/brand/$clientId",
      params: { clientId: params.clientId },
      replace: true,
    });
  },
});
